(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const hydrateDropdownImages = (scope) => {
      scope.querySelectorAll('[data-ushore-deferred-dropdown-image]').forEach((template) => {
        template.replaceWith(template.content.cloneNode(true));
      });
    };

    document.addEventListener('pointerover', (event) => {
      const trigger = event.target.closest('.ushore-header-nav__item--shop');
      if (!trigger) return;
      hydrateDropdownImages(trigger);
    }, { passive: true });

    document.addEventListener('focusin', (event) => {
      const trigger = event.target.closest('.ushore-header-nav__item--shop');
      if (!trigger) return;
      hydrateDropdownImages(trigger);
    });
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};
      this.headerHeightTarget = this.querySelector('.header') || this.header.querySelector('.header') || this.header;
      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');

      this.setHeaderHeight();

      this.headerMediaQuery.addEventListener('change', this.boundSetHeaderHeight);
      window.addEventListener('resize', this.boundSetHeaderHeight);
      window.addEventListener('load', this.boundSetHeaderHeight, { once: true });
      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(this.boundSetHeaderHeight);
        this.headerResizeObserver.observe(this.headerHeightTarget);
      }

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = () => {};
      this.hideHeaderOnScrollUp = () => {};
    }

    setHeaderHeight() {
      const measuredHeight = this.headerHeightTarget?.getBoundingClientRect().height || this.headerHeightTarget?.offsetHeight || this.header.offsetHeight || 0;
      const minHeight = window.matchMedia('(min-width: 990px)').matches ? 56 : 52;
      const maxHeight = window.matchMedia('(min-width: 990px)').matches ? 88 : 78;
      const headerHeight = Math.min(Math.max(Math.round(measuredHeight), minHeight), maxHeight);
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.boundSetHeaderHeight);
      this.headerMediaQuery?.removeEventListener('change', this.boundSetHeaderHeight);
      this.headerResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const headerSelectors = [
      '.shopify-section-group-header-group .header.page-width',
      '.shopify-section-group-header-group .header',
      '.shopify-section-group-header-group .header-wrapper',
      '.shopify-section-group-header-group sticky-header',
      '.shopify-section-group-header-group',
    ];

    let grid;
    let sortBar;
    let clone;
    let startY = 0;
    let raf = 0;

    const headerBottom = () => {
      const measuredBottom = headerSelectors.reduce((bottom, selector) => {
        const element = document.querySelector(selector);
        if (!element) return bottom;
        const rect = element.getBoundingClientRect();
        return Math.max(bottom, rect.bottom || 0, rect.height || 0, element.offsetHeight || 0);
      }, 0);
      const cssHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ushore-header-height')) || 0;
      return Math.ceil(Math.max(measuredBottom, cssHeight));
    };

    const removeClone = () => {
      clone?.remove();
      clone = null;
      grid?.classList.remove('ushore-mobile-sort-active');
      document.documentElement.style.removeProperty('--ushore-mobile-sort-top');
      document.documentElement.style.removeProperty('--ushore-mobile-sort-left');
      document.documentElement.style.removeProperty('--ushore-mobile-sort-width');
    };

    const prepareClone = () => {
      if (clone || !sortBar) return;
      clone = sortBar.cloneNode(true);
      clone.classList.add('ushore-mobile-sort-clone');
      clone.querySelectorAll('[id]').forEach((element) => {
        element.id = `${element.id}-mobile-sticky`;
      });
      clone.querySelectorAll('[for]').forEach((element) => {
        element.setAttribute('for', `${element.getAttribute('for')}-mobile-sticky`);
      });
      document.body.appendChild(clone);
    };

    const measure = () => {
      removeClone();
      grid = document.querySelector('.ushore-collection-grid');
      sortBar = grid?.querySelector('.ushore-collection-grid__header');
      if (!grid || !sortBar) return;
      startY = sortBar.getBoundingClientRect().top + window.scrollY;
    };

    const update = () => {
      raf = 0;
      if (!mobileMedia.matches) {
        removeClone();
        return;
      }

      if (!grid || !sortBar) measure();
      if (!grid || !sortBar) return;

      const top = Math.max(0, headerBottom() - 1);
      const gridRect = grid.getBoundingClientRect();
      const sortHeight = sortBar.offsetHeight || 0;
      const shouldPin = window.scrollY + top >= startY && gridRect.bottom > top + sortHeight;

      document.documentElement.style.setProperty('--ushore-mobile-sort-top', `${top}px`);
      document.documentElement.style.setProperty('--ushore-mobile-sort-left', `${Math.round(gridRect.left)}px`);
      document.documentElement.style.setProperty('--ushore-mobile-sort-width', `${Math.round(gridRect.width)}px`);

      if (shouldPin) {
        prepareClone();
        grid.classList.add('ushore-mobile-sort-active');
      } else {
        removeClone();
      }
    };

    const schedule = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    };

    window.ushoreRefreshMobileCollectionSort = () => {
      measure();
      schedule();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window.ushoreRefreshMobileCollectionSort, { once: true });
    } else {
      window.ushoreRefreshMobileCollectionSort();
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', window.ushoreRefreshMobileCollectionSort);
    mobileMedia.addEventListener('change', window.ushoreRefreshMobileCollectionSort);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const headerSelectors = [
      '.shopify-section-group-header-group .header.page-width',
      '.shopify-section-group-header-group .header',
      '.shopify-section-group-header-group .header-wrapper',
      '.shopify-section-group-header-group sticky-header',
      '.shopify-section-group-header-group',
    ];

    let root;
    let clone;
    let raf = 0;

    const headerBottom = () => {
      const measuredBottom = headerSelectors.reduce((bottom, selector) => {
        const element = document.querySelector(selector);
        if (!element) return bottom;
        const rect = element.getBoundingClientRect();
        return Math.max(bottom, rect.bottom || 0, rect.height || 0, element.offsetHeight || 0);
      }, 0);
      const cssHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ushore-header-height')) || 0;
      return Math.ceil(Math.max(measuredBottom, cssHeight));
    };

    const removeClone = () => {
      clone?.remove();
      clone = null;
      root?.classList.remove('ushore-campaign-mobile-sticky-active');
      root?.querySelectorAll('.ushore-campaign-mobile-active').forEach((group) => {
        group.classList.remove('ushore-campaign-mobile-active');
      });
      document.documentElement.style.removeProperty('--ushore-campaign-mobile-sticky-top');
      document.documentElement.style.removeProperty('--ushore-campaign-mobile-sticky-left');
      document.documentElement.style.removeProperty('--ushore-campaign-mobile-sticky-width');
      document.documentElement.style.removeProperty('--ushore-campaign-mobile-sticky-shift');
    };

    const ensureClone = () => {
      if (clone) return clone;
      clone = document.createElement('div');
      clone.className = 'ushore-campaign-mobile-sticky';
      clone.setAttribute('aria-hidden', 'true');
      document.body.appendChild(clone);
      return clone;
    };

    const copyTextStyles = (sticky, activeIntro) => {
      const pairs = [
        ['p', '--ushore-sticky-year'],
        ['h2', '--ushore-sticky-heading'],
        ['.rte', '--ushore-sticky-copy'],
      ];

      pairs.forEach(([selector, prefix]) => {
        const source = activeIntro.querySelector(selector);
        if (!source) return;
        const style = getComputedStyle(source);
        sticky.style.setProperty(`${prefix}-color`, style.color);
        sticky.style.setProperty(`${prefix}-family`, style.fontFamily);
        sticky.style.setProperty(`${prefix}-size`, style.fontSize);
        sticky.style.setProperty(`${prefix}-weight`, style.fontWeight);
        sticky.style.setProperty(`${prefix}-line-height`, style.lineHeight);
        sticky.style.setProperty(`${prefix}-transform`, style.textTransform);
      });
    };

    const update = () => {
      raf = 0;
      root = root || document.querySelector('.ushore-page-campaigns');

      if (!mobileMedia.matches || !root) {
        removeClone();
        return;
      }

      const top = Math.max(0, headerBottom() - 2);
      const rootRect = root.getBoundingClientRect();
      const groups = Array.from(root.querySelectorAll('.ushore-page-campaigns__group'));
      let activeGroup = null;

      groups.forEach((group) => {
        const intro = group.querySelector('.ushore-page-campaigns__intro');
        if (!intro) return;
        if (intro.getBoundingClientRect().top <= top + 1) {
          activeGroup = group;
        }
      });

      const activeIntro = activeGroup?.querySelector('.ushore-page-campaigns__intro');

      if (!activeIntro || rootRect.bottom <= top + 56) {
        removeClone();
        return;
      }

      const introRect = activeIntro.getBoundingClientRect();
      document.documentElement.style.setProperty('--ushore-campaign-mobile-sticky-top', `${top}px`);
      document.documentElement.style.setProperty('--ushore-campaign-mobile-sticky-left', `${Math.round(introRect.left)}px`);
      document.documentElement.style.setProperty('--ushore-campaign-mobile-sticky-width', `${Math.round(introRect.width)}px`);

      groups.forEach((group) => {
        group.classList.toggle('ushore-campaign-mobile-active', group === activeGroup);
      });

      const sticky = ensureClone();
      sticky.innerHTML = activeIntro.innerHTML;
      copyTextStyles(sticky, activeIntro);

      const stickyHeight = sticky.offsetHeight || activeIntro.offsetHeight || 0;
      const activeIndex = groups.indexOf(activeGroup);
      const nextIntro = groups[activeIndex + 1]?.querySelector('.ushore-page-campaigns__intro');
      let stickyShift = 0;

      if (nextIntro && stickyHeight > 0) {
        const nextIntroTop = nextIntro.getBoundingClientRect().top;
        stickyShift = Math.max(stickyHeight * -1, Math.min(0, nextIntroTop - (top + stickyHeight)));
      }

      document.documentElement.style.setProperty('--ushore-campaign-mobile-sticky-shift', `${stickyShift.toFixed(2)}px`);
      root.classList.add('ushore-campaign-mobile-sticky-active');
    };

    const schedule = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
      schedule();
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    mobileMedia.addEventListener('change', schedule);

    const openFaqItem = (item, answer) => {
      item.open = true;
      answer.style.maxHeight = '0px';
      answer.style.opacity = '0';
      requestAnimationFrame(() => {
        answer.style.maxHeight = `${answer.scrollHeight}px`;
        answer.style.opacity = '1';
      });
      answer.addEventListener('transitionend', () => {
        if (item.open) answer.style.maxHeight = '';
      }, { once: true });
    };

    const closeFaqItem = (item, answer) => {
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      answer.style.opacity = '1';
      requestAnimationFrame(() => {
        answer.style.maxHeight = '0px';
        answer.style.opacity = '0';
      });
      answer.addEventListener('transitionend', () => {
        item.open = false;
        answer.style.maxHeight = '';
        answer.style.opacity = '';
      }, { once: true });
    };

    if (!window.ushoreMainPageFaqListenerAttached) {
      window.ushoreMainPageFaqListenerAttached = true;
      document.addEventListener('click', (event) => {
        const summary = event.target.closest('.ushore-page-faq__question');
        if (!summary) return;

        const item = summary.closest('.ushore-page-faq__item');
        const answer = item && item.querySelector('.ushore-page-faq__answer');
        if (!item || !answer) return;

        event.preventDefault();
        item.open ? closeFaqItem(item, answer) : openFaqItem(item, answer);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ushore-collection-tiles"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__ushoreCollectionTilesProgressInit) return;
  window.__ushoreCollectionTilesProgressInit = true;

  const updateProgress = (section) => {
    const track = section?.querySelector('.ushore-landing-categories__grid');
    const progress = section?.querySelector('.ushore-landing-categories__progress');
    if (!track || !progress) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const visibleRatio = track.clientWidth / track.scrollWidth;
      const railWidth = progress.clientWidth;
      const progressWidth = Math.max(visibleRatio * 100, 20);
      const maxTravel = railWidth * (1 - progressWidth / 100);
      const progressLeft = maxScroll > 0 ? (track.scrollLeft / maxScroll) * maxTravel : 0;
      progress.style.setProperty('--ushore-category-progress-width', `${progressWidth}%`);
      progress.style.setProperty('--ushore-category-progress-left', `${progressLeft}px`);
  };

  const init = () => {
    document.querySelectorAll('.ushore-landing-categories').forEach((section) => {
      const track = section.querySelector('.ushore-landing-categories__grid');
      if (!track) return;
      updateProgress(section);
      track.addEventListener('scroll', () => updateProgress(section), { passive: true });
      window.addEventListener('resize', () => updateProgress(section), { passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ushore-edge-product-strip"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__ushoreEdgeProductsInit) return;
  window.__ushoreEdgeProductsInit = true;

  const updateUshoreEdgeArrows = (section) => {
    const track = section?.querySelector('.ushore-edge-products__track');
    const prev = section?.querySelector('[data-ushore-edge-prev]');
    const next = section?.querySelector('[data-ushore-edge-next]');
    const progress = section?.querySelector('.ushore-edge-products__progress');
    if (!track) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;

    if (prev && next) {
      prev.disabled = atStart;
      next.disabled = atEnd || maxScroll <= 2;
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd || maxScroll <= 2 ? 'true' : 'false');
    }

    if (progress) {
      const railWidth = progress.clientWidth;
      const visibleRatio = track.clientWidth / track.scrollWidth;
      const progressWidth = Math.max(visibleRatio * 100, 18);
      const maxTravel = railWidth * (1 - progressWidth / 100);
      const progressLeft = maxScroll > 0 ? (track.scrollLeft / maxScroll) * maxTravel : 0;
      progress.style.setProperty('--ushore-edge-progress-width', `${progressWidth}%`);
      progress.style.setProperty('--ushore-edge-progress-left', `${progressLeft}px`);
    }
  };

  const initUshoreEdgeProducts = () => {
    document.querySelectorAll('.ushore-edge-products').forEach((section) => {
      const track = section.querySelector('.ushore-edge-products__track');
      if (!track) return;
      updateUshoreEdgeArrows(section);
      track.addEventListener('scroll', () => updateUshoreEdgeArrows(section), { passive: true });
    });
  };

  const hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const hydrateSecondaryImage = (card) => {
    if (!hoverMediaQuery.matches) return;
    const template = card.querySelector('[data-ushore-edge-secondary-template]');
    const media = template?.closest('.ushore-edge-products__media');
    if (!template || !media) return;
    media.appendChild(template.content.cloneNode(true));
    template.remove();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ushore-edge-prev], [data-ushore-edge-next]');
    if (!button || button.disabled) return;

    const section = button.closest('.ushore-edge-products');
    const track = section?.querySelector('.ushore-edge-products__track');
    const card = track?.querySelector('.ushore-edge-products__card');
    if (!track || !card) return;

    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    const direction = button.matches('[data-ushore-edge-prev]') ? -1 : 1;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    window.setTimeout(() => updateUshoreEdgeArrows(section), 320);
  });

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest('.ushore-edge-products__card');
    if (!card) return;
    hydrateSecondaryImage(card);
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const card = event.target.closest('.ushore-edge-products__card');
    if (!card) return;
    hydrateSecondaryImage(card);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUshoreEdgeProducts);
  } else {
    initUshoreEdgeProducts();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ushore-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMotionHero = (scope = document) => {
      const root = scope.nodeType === 1 ? scope : document;
      const scopedHero = root.matches && root.matches('[data-ushore-motion-hero]') ? [root] : [];
      const heroes = [...scopedHero, ...root.querySelectorAll('[data-ushore-motion-hero]')];

      heroes.forEach((hero) => {
        if (hero.dataset.ushoreMotionInit === 'true') return;

        hero.dataset.ushoreMotionInit = 'true';

        const reveal = () => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              hero.classList.add('ushore-hero--motion-ready');
              window.setTimeout(() => {
                hero.classList.add('ushore-hero--motion-settled');
                hero.classList.remove('ushore-hero--motion-prep');
                hero.classList.remove('ushore-hero--motion-ready');
              }, 1850);
            });
          });
        };

        if (!('IntersectionObserver' in window)) {
          reveal();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              reveal();
              observer.disconnect();
            });
          },
          { rootMargin: '120px 0px', threshold: 0.2 }
        );

        observer.observe(hero);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initMotionHero(), { once: true });
    } else {
      initMotionHero();
    }

    document.addEventListener('shopify:section:load', (event) => initMotionHero(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ushore-follow-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const videoSelector = '.ushore-follow-grid__video';

    const playVideo = (video) => {
      if (!video || !video.getClientRects().length) return;
      video.muted = true;
      video.autoplay = true;
      video.controls = false;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      video.preload = 'metadata';

      const playRequest = video.play();
      if (playRequest && typeof playRequest.catch === 'function') {
        playRequest.catch(() => {});
      }
    };

    const playSectionVideos = (section) => {
      section.querySelectorAll(videoSelector).forEach(playVideo);
    };

    const isSectionVisible = (section) => {
      const rect = section.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    };

    const initializeFollowVideos = (scope = document) => {
      const sections = scope.querySelectorAll('.ushore-follow-grid');
      if (!sections.length) return;

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              playSectionVideos(entry.target);
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.01 }
        );

        sections.forEach((section) => observer.observe(section));
      } else {
        sections.forEach(playSectionVideos);
      }
    };

    const retryPlayback = () => {
      document.querySelectorAll('.ushore-follow-grid').forEach((section) => {
        if (isSectionVisible(section)) playSectionVideos(section);
      });
    };

    initializeFollowVideos();
    document.addEventListener('shopify:section:load', (event) => initializeFollowVideos(event.target));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) retryPlayback();
    });
    document.addEventListener('pointerdown', retryPlayback, { once: true, passive: true });
    document.addEventListener('touchstart', retryPlayback, { once: true, passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ushore-image-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initImageFaders = (scope = document) => {
      scope.querySelectorAll('[data-ushore-image-fader]').forEach((fader) => {
        if (fader.dataset.ushoreFaderReady === 'true') return;

        const slides = Array.from(fader.querySelectorAll('.ushore-image-carousel__slide'));
        if (slides.length < 2) return;

        fader.dataset.ushoreFaderReady = 'true';
        let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (index < 0) index = 0;

        const show = (nextIndex) => {
          slides[index].classList.remove('is-active');
          index = (nextIndex + slides.length) % slides.length;
          slides[index].classList.add('is-active');
        };

        const speed = Number.parseInt(window.getComputedStyle(fader).getPropertyValue('--carousel-speed'), 10) || 4200;
        window.setInterval(() => show(index + 1), speed);
      });
    };

    initImageFaders();
    document.addEventListener('shopify:section:load', (event) => initImageFaders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ushore-page-story"] && !Shopify.designMode) return;
  try {
    
  function openUshorePageFaqItem(item, answer) {
    item.open = true;
    answer.style.maxHeight = '0px';
    answer.style.opacity = '0';
    requestAnimationFrame(() => {
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      answer.style.opacity = '1';
    });
    answer.addEventListener('transitionend', () => {
      if (item.open) answer.style.maxHeight = '';
    }, { once: true });
  }

  function closeUshorePageFaqItem(item, answer) {
    answer.style.maxHeight = `${answer.scrollHeight}px`;
    answer.style.opacity = '1';
    requestAnimationFrame(() => {
      answer.style.maxHeight = '0px';
      answer.style.opacity = '0';
    });
    answer.addEventListener('transitionend', () => {
      item.open = false;
      answer.style.maxHeight = '';
      answer.style.opacity = '';
    }, { once: true });
  }

  if (!window.ushorePageFaqListenerAttached) {
    window.ushorePageFaqListenerAttached = true;

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.ushore-page-faq__question');
      if (!summary) return;

      const item = summary.closest('.ushore-page-faq__item');
      const answer = item && item.querySelector('.ushore-page-faq__answer');
      if (!item || !answer) return;

      event.preventDefault();
      item.open ? closeUshorePageFaqItem(item, answer) : openUshorePageFaqItem(item, answer);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ushore-social-proof"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ushore-proof]').forEach((section) => {
    const slides = [...section.querySelectorAll('[data-ushore-proof-slide]')];
    const images = [...section.querySelectorAll('[data-ushore-proof-image]')];
    const previous = section.querySelector('[data-ushore-proof-prev]');
    const next = section.querySelector('[data-ushore-proof-next]');
    let active = 0;

    if (slides.length < 2) return;

    const setActive = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === active));
      images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === active));
    };

    previous?.addEventListener('click', () => setActive(active - 1));
    next?.addEventListener('click', () => setActive(active + 1));
  });

  } catch(e) { console.error(e); }
})();
})();
